import React from "react";
import { useCart } from "../cart/CartContext";
import PayPalButton from "./PayPalButton";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function CartDrawer() {
  const { items, subtotal, currency, setQty, removeItem } = useCart();
  const { currentUser, userData } = useAuth();
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  const handleCompleteDetails = () => {
    navigate("/signup-details");
  };

  return (
    <main
      style={{
        maxWidth: 900,
        margin: "40px auto",
        padding: "0 20px",
        background: "#fff",
        borderRadius: 12,
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
      }}
    >
      <h1 style={{ textAlign: "center", marginTop: 30 }}>Your Cart</h1>

      {items.length === 0 ? (
        <p style={{ textAlign: "center", padding: 30 }}>Your cart is empty.</p>
      ) : (
        <>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {items.map((it) => (
              <li
                key={it.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid rgba(0,0,0,0.06)",
                  padding: "16px 0",
                }}
              >
                <img
                  src={it.image}
                  alt={it.name}
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: "cover",
                    borderRadius: 8,
                    marginRight: 16,
                  }}
                />
                <div style={{ flex: 1 }}>
                  <strong>{it.name}</strong>
                  <p style={{ margin: "6px 0", color: "#555" }}>
                    {it.price} {it.currency}
                  </p>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <label>Qty:</label>
                    <input
                      type="number"
                      min="1"
                      value={it.quantity}
                      onChange={(e) => setQty(it.id, Number(e.target.value))}
                      style={{
                        width: 60,
                        padding: 4,
                        textAlign: "center",
                        borderRadius: 6,
                        border: "1px solid rgba(0,0,0,0.1)",
                      }}
                    />
                    <button
                      onClick={() => removeItem(it.id)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#c00",
                        cursor: "pointer",
                      }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {/* 🟢 Subtotal */}
          <div
            style={{
              textAlign: "left",
              marginTop: 20,
              fontSize: "1.1rem",
              fontWeight: "bold",
              paddingLeft: 4,
            }}
          >
            Subtotal: {subtotal.toFixed(2)} {currency}
          </div>

          <div
            style={{
              marginTop: 40,
              textAlign: "center",
              borderTop: "1px solid rgba(0,0,0,0.08)",
              paddingTop: 30,
              paddingBottom: 30, // ⭐ מוסיף ריווח מתחת לכפתור
            }}
          >
            {/* 🔐 לא מחובר */}
            {!currentUser ? (
              <div>
                <p style={{ marginBottom: 12 }}>
                  Please log in to complete your purchase.
                </p>
                <button
                  onClick={handleLoginRedirect}
                  style={{
                    background: "linear-gradient(90deg, #222, #444)",
                    color: "#fff",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: 8,
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  Login to Checkout
                </button>
              </div>
            ) : (
              <>
                {/* 🔥 מחובר אבל לא מילא פרטים */}
                {userData?.signUpStage !== "complete" ? (
                  <div>
                    <p
                      style={{
                        marginBottom: 12,
                        fontWeight: 500,
                        color: "#444",
                      }}
                    >
                      Please complete your shipping details to continue.
                    </p>
                    <button
                      onClick={handleCompleteDetails}
                      style={{
                        background: "linear-gradient(90deg, #222, #444)",
                        color: "#fff",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: 8,
                        cursor: "pointer",
                        fontWeight: 600,
                        marginTop: 16,
                        minWidth: 180,
                      }}
                    >
                      Checkout
                    </button>
                  </div>
                ) : (
                  /* ⭐ מחובר + פרטים מלאים */
                  <div>
                    <h3 style={{ marginBottom: 15 }}>Complete Your Purchase</h3>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        marginTop: 10,
                      }}
                    >
                      <div style={{ width: 280, maxWidth: "100%" }}>
                        <PayPalButton total={subtotal} currency={currency} />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </main>
  );
}
